const VERSION = "21.0.2";
export {
  VERSION
};
